
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Meta, Story } from '@storybook/addon-docs';
import { useEffect } from '@storybook/client-api';
import { basename, extname } from 'path';
import sampleDemo from './demo/sample.twig';
import './config.js';
// Load samples directory as "raw" text
const samplesDir = require.context('!!raw-loader!./demo/samples', false);
// Initialize an object to store sample content in
const samples = {};
// For each sample, fetch its content and build an object for our template
for (const key of samplesDir.keys()) {
  const filename = basename(key);
  const ext = extname(key);
  const name = filename.replace(ext, '');
  const content = samplesDir(key).default;
  samples[name] = { filename, name, ext, content };
}


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Vendor/Prism" decorators={[storyFn => {
      useEffect(() => Prism.highlightAll());
      return storyFn();
    }]} mdxType="Meta" />
    <h1>{`Prism`}</h1>
    <p>{`Our CSS includes a custom `}<a parentName="p" {...{
        "href": "https://prismjs.com/index.html"
      }}>{`Prism`}</a>{` theme to support syntax highlighting for code samples.`}</p>
    <h2>{`Supported Languages`}</h2>
    <Story name="Bash, Shell" mdxType="Story">{sampleDemo(samples.bash)}</Story>
    <Story name="CSS" mdxType="Story">{sampleDemo(samples.css)}</Story>
    <Story name="Handlebars" mdxType="Story">{sampleDemo(samples.handlebars)}</Story>
    <Story name="JavaScript" mdxType="Story">{sampleDemo(samples.js)}</Story>
    <Story name="JSON" mdxType="Story">{sampleDemo(samples.json)}</Story>
    <Story name="Liquid" mdxType="Story">{sampleDemo(samples.liquid)}</Story>
    <Story name="Markup, HTML" mdxType="Story">{sampleDemo(samples.markup)}</Story>
    <Story name="PHP" mdxType="Story">{sampleDemo(samples.php)}</Story>
    <Story name="React JSX" mdxType="Story">{sampleDemo(samples.jsx)}</Story>
    <Story name="React TSX" mdxType="Story">{sampleDemo(samples.tsx)}</Story>
    <Story name="Sass (SCSS)" mdxType="Story">{sampleDemo(samples.scss)}</Story>
    <Story name="TOML" mdxType="Story">{sampleDemo(samples.toml)}</Story>
    <Story name="Twig" mdxType="Story">{sampleDemo(samples.twig)}</Story>
    <Story name="TypeScript" mdxType="Story">{sampleDemo(samples.typescript)}</Story>
    <Story name="YAML" mdxType="Story">{sampleDemo(samples.yaml)}</Story>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const bashShell = () => (
          sampleDemo(samples.bash)
        );
bashShell.storyName = 'Bash, Shell';
bashShell.parameters = { storySource: { source: 'sampleDemo(samples.bash)' } };

export const css = () => (
          sampleDemo(samples.css)
        );
css.storyName = 'CSS';
css.parameters = { storySource: { source: 'sampleDemo(samples.css)' } };

export const handlebars = () => (
          sampleDemo(samples.handlebars)
        );
handlebars.storyName = 'Handlebars';
handlebars.parameters = { storySource: { source: 'sampleDemo(samples.handlebars)' } };

export const javaScript = () => (
          sampleDemo(samples.js)
        );
javaScript.storyName = 'JavaScript';
javaScript.parameters = { storySource: { source: 'sampleDemo(samples.js)' } };

export const json = () => (
          sampleDemo(samples.json)
        );
json.storyName = 'JSON';
json.parameters = { storySource: { source: 'sampleDemo(samples.json)' } };

export const liquid = () => (
          sampleDemo(samples.liquid)
        );
liquid.storyName = 'Liquid';
liquid.parameters = { storySource: { source: 'sampleDemo(samples.liquid)' } };

export const markupHtml = () => (
          sampleDemo(samples.markup)
        );
markupHtml.storyName = 'Markup, HTML';
markupHtml.parameters = { storySource: { source: 'sampleDemo(samples.markup)' } };

export const php = () => (
          sampleDemo(samples.php)
        );
php.storyName = 'PHP';
php.parameters = { storySource: { source: 'sampleDemo(samples.php)' } };

export const reactJsx = () => (
          sampleDemo(samples.jsx)
        );
reactJsx.storyName = 'React JSX';
reactJsx.parameters = { storySource: { source: 'sampleDemo(samples.jsx)' } };

export const reactTsx = () => (
          sampleDemo(samples.tsx)
        );
reactTsx.storyName = 'React TSX';
reactTsx.parameters = { storySource: { source: 'sampleDemo(samples.tsx)' } };

export const sassScss = () => (
          sampleDemo(samples.scss)
        );
sassScss.storyName = 'Sass (SCSS)';
sassScss.parameters = { storySource: { source: 'sampleDemo(samples.scss)' } };

export const toml = () => (
          sampleDemo(samples.toml)
        );
toml.storyName = 'TOML';
toml.parameters = { storySource: { source: 'sampleDemo(samples.toml)' } };

export const twig = () => (
          sampleDemo(samples.twig)
        );
twig.storyName = 'Twig';
twig.parameters = { storySource: { source: 'sampleDemo(samples.twig)' } };

export const typeScript = () => (
          sampleDemo(samples.typescript)
        );
typeScript.storyName = 'TypeScript';
typeScript.parameters = { storySource: { source: 'sampleDemo(samples.typescript)' } };

export const yaml = () => (
          sampleDemo(samples.yaml)
        );
yaml.storyName = 'YAML';
yaml.parameters = { storySource: { source: 'sampleDemo(samples.yaml)' } };

const componentMeta = { title: 'Vendor/Prism', decorators: [storyFn => {
  useEffect(() => Prism.highlightAll());
  return storyFn();
}], includeStories: ["bashShell","css","handlebars","javaScript","json","liquid","markupHtml","php","reactJsx","reactTsx","sassScss","toml","twig","typeScript","yaml"],  };

const mdxStoryNameToKey = {"Bash, Shell":"bashShell","CSS":"css","Handlebars":"handlebars","JavaScript":"javaScript","JSON":"json","Liquid":"liquid","Markup, HTML":"markupHtml","PHP":"php","React JSX":"reactJsx","React TSX":"reactTsx","Sass (SCSS)":"sassScss","TOML":"toml","Twig":"twig","TypeScript":"typeScript","YAML":"yaml"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;